export default {"src":"/_next/static/media/right-chevron.9c87af89.svg","height":24,"width":13,"blurWidth":0,"blurHeight":0};